import { render, staticRenderFns } from "./InspectionReservationRegister.vue?vue&type=template&id=bf45defc&scoped=true&lang=pug"
import script from "./InspectionReservationRegister.vue?vue&type=script&lang=ts"
export * from "./InspectionReservationRegister.vue?vue&type=script&lang=ts"
import style0 from "./InspectionReservationRegister.vue?vue&type=style&index=0&id=bf45defc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf45defc",
  null
  
)

export default component.exports